import process from "next/dist/build/webpack/loaders/resolve-url-loader/lib/postcss";

export const sendForm = async (formId, data) => {
    const result = await fetch(process.env.NEXT_PUBLIC_API_URL + `/contact-form-7/v1/contact-forms/${formId}/feedback`, {
        method: 'POST',
        body: data
    })
    return await result.json()
}